import React, { useState, useEffect } from 'react';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import WaterMark from '../../../Dashboard/DashboardMain/WaterMark';
import ChartLoader from '../../Driveanalysis_Bus/ChartLoader';
// import Table from '../../Faultanalysis_Bus/FaultFirstPage_Bus/Table';
import Table from './Table';
import NoTableData from '../../../Dashboard/Driveanalysis/NoTableData';
import * as $ from 'jquery';

export default function DataBarSection(props) {
  let { title, template_id, show, soarting, gloablfilter, IND } = props;
  const [faultSelected, setfaultSelected] = useState("Occurrence");
  const [faultSelectedimbalance, setfaultSelectedimbalance] = useState("Duration");
  const [faultPercentAlram, setFaultPercentAlram] = useState([]);
  const [faultPercentAlram_, setFaultPercentAlram_] = useState([]);
  const [faultPercentDtc, setFaultPercentDtc] = useState([]);
  const [faultPercentDtc_, setFaultPercentDtc_] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [tableheadNew, settableheadNew] = useState([]);
  const [tableDataImbalnce, setTableDataImbalance] = useState([]);
  const [tablehead, settablehead] = useState([]);
  const [tableDtcData, setTableDtcData] = useState([]);
  const [tableDtcData_, setTableDtcData_] = useState([]);
  const [tableAlarmData, setTableAlarmData] = useState([]);
  const [tableAlarmData_, setTableAlarmData_] = useState([]);
  const [faultPercent, setFaultPercent] = useState([]);
  const [tableBarData, setTableBarData] = useState([]);

  const { isLoading, error, sendReq: fetchData } = useHttp();
  let post_fix = "";

  if (IND === "RANGE") {
    post_fix = "Km";
  }

  const singleVinSelected = (vin) => {
    props.singleVinSelected(vin);
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + 'faultfirstpage_bus/Topvehicleswithfaults_bus_occ', body: { filterdata: gloablfilter, IND } }, appyData)
    fetchData({ url: API_URL_MAIN + "faultfirstpage_bus/Topvehicleswithfaults_imbalance_dur", body: { filterdata: gloablfilter, IND } }, appyDataDuration_imbalance)

    fetchData({ url: API_URL_MAIN + 'faultfirstpage_bus/faultanalysis_bus', body: { filterdata: gloablfilter, IND } }, appyBarData);
    fetchData({ url: API_URL_MAIN + 'faultfirstpage_bus/fault_alarmanalysis_bus', body: { filterdata: gloablfilter, IND } }, appyDtcData);
  }, [gloablfilter]);

  const [boxOne, setBoxOne] = useState(true)
  const [boxTwo, setBoxTwo] = useState(true)

  const filterChnaged = (event) => {
    setBoxOne(true)
    setBoxTwo(false)
    setfaultSelected(event.target.value)
    let value = event.target.value
    if (value === "Duration") {
      fetchData({ url: API_URL_MAIN + "faultfirstpage_bus/Topvehicleswithfaults_bus_dur", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyDataDuration)
    } else {
      fetchData({ url: API_URL_MAIN + "faultfirstpage_bus/Topvehicleswithfaults_bus_occ", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyData)
    }
  }

  const filterChnaged_imbalance = (event) => {
    setBoxOne(false)
    setBoxTwo(true)
    setfaultSelectedimbalance(event.target.value)
    let value = event.target.value
    if (value === "Duration") {
      fetchData({ url: API_URL_MAIN + "faultfirstpage_bus/Topvehicleswithfaults_imbalance_dur", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyDataDuration_imbalance)
    } else {
      fetchData({ url: API_URL_MAIN + "faultfirstpage_bus/Topvehicleswithfaults_imbalance_occ", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyDataimbalance)
    }
  }

  const appyData = (data) => {
    const thead = { "head1": "Vin", "head2": "Occurrence" };
    const res_result = data;
    let responce = [];
    if (res_result.length !== 0) {
      let temp_result = res_result;
      temp_result.map(obj => {
        responce.push({ key: obj.key.vehicleId, occ: (obj.occurance.value) })
      })
      setTableData((prestate) => responce);
      settableheadNew(thead)
    } else {
      setTableData((prestate) => []);
      settableheadNew([])
    }
  }

  const appyDataDuration = (data) => {
    const res_result = data;
    const thead = { "head1": "Vin", "head2": "Mins" };
    let responce = [];
    if (res_result.length !== 0) {
      let temp_result = res_result;
      temp_result.map(obj => {
        responce.push({ key: obj.key.vehicleId, occ: (obj.duration.value) })
      })
      setTableData((prestate) => responce);
      settableheadNew(thead)
    } else {
      setTableData((prestate) => []);
      settableheadNew({})
    }
  }

  const appyDataDuration_imbalance = (data) => {
    const res_result = data;
    const thead = { "head1": "Vin", "head2": "Mins" };
    let responce = [];
    if (res_result.length !== 0) {
      let temp_result = res_result;
      temp_result.map(obj => {
        responce.push({ key: obj.key.vehicleId, occ: (obj.duration.value) })
      })
      setTableDataImbalance((prestate) => responce);
      settablehead(thead)
    } else {
      setTableDataImbalance((prestate) => []);
    }
  }

  const appyDataimbalance = (data) => {
    const thead = { "head1": "Vin", "head2": "Occurrence" };
    const res_result = data;
    let responce = [];
    if (res_result.length !== 0) {
      let temp_result = res_result;
      temp_result.map(obj => {
        responce.push({ key: obj.key.vehicleId, occ: (obj.occurance.value) })
      })
      setTableDataImbalance((prestate) => responce);
      // setTableData(addECU(data,"occ"));
      settablehead(thead)
    } else {
      setTableDataImbalance((prestate) => []);
      settablehead([])
    }
  }

  const appyBarData = (data) => {

    const thead = { "head1": "Vin", "head2": "Occurrence" };
    const mainECU = [{ "key": "BCS-1", "vehicle_count": 0, "count": 0 }, { "key": "BCS-2", "vehicle_count": 0, "count": 0 }, { "key": "BMS", "vehicle_count": 0, "count": 0 }, { "key": "HVAC", "vehicle_count": 0, "count": 0 }, { "key": "VCU", "vehicle_count": 0, "count": 0 }, { "key": "Aux-1", "vehicle_count": 0, "count": 0 }, { "key": "Aux-2", "vehicle_count": 0, "count": 0 }, { "key": "MCU", "vehicle_count": 0, "count": 0 }];
    const res_result = data;
    let responce = [];
    let temp_result = res_result;
    temp_result.map(obj => {
      responce.push({ key: obj.key.ECU, vehicle_count: (obj.vehicle_count.value) })
    })
    const ecu = addECU(data, "vehicle_count")
    const ecu_ = addECU_(data, "vehicle_count")
    setFaultPercentAlram(addECUPercentFault(ecu, data));
    setFaultPercentAlram_(addECUPercentFault_(ecu_, data));
    setTableAlarmData(ecu);
    setTableAlarmData_(ecu_)
  }

  const appyDtcData = (data) => {
    const thead = { "head1": "Vin", "head2": "Count" };
    const res_result = data;
    let responce = [];
    let temp_result = res_result;
    temp_result.map(obj => {
      responce.push({ key: obj.key.ECU, vehicle_count: (obj.vehicle_count.value) })
    })
    const ecu = addECU(data, "vehicle_count")
    const ecu_ = addECU_(data, "vehicle_count")
    setFaultPercentDtc(addECUPercentFault(ecu, data));
    setTableDtcData(ecu);
    const x = ecu_.shift();
    setFaultPercentDtc_(addECUPercentFault_(ecu_, data));
    setTableDtcData_(ecu_);
  }

  function addECU(dataArr, chngKey) {
    const mainECU = ["BCS-1", "BCS-2", "BMS", "HVAC", "VCU", "Aux-1", "Aux-2", "MCU", "DC-DC"];
    mainECU.forEach(element => {
      var index = dataArr.findIndex(x => x.key.ECU === element);
      index === -1 && dataArr.push({
        "key": { "ECU": element }, "doc_count": 0, [`${chngKey}`]: { "value": 0 }
      })
    });
    let dataA = dataArr.sort(function (a, b) {
      return a.key.ECU.localeCompare(b.key.ECU);
    });
    let dataB = []
    for (let i = 0; i < 5; i = i + 1) {
      dataB[i] = dataA[i]
    }
    return dataB;
  }

  function addECU_(dataArr, chngKey) {
    const mainECU = ["BCS-1", "BCS-2", "BMS", "HVAC", "VCU", "Aux-1", "Aux-2", "MCU", "DC-DC"];
    mainECU.forEach(element => {
      var index = dataArr.findIndex(x => x.key.ECU === element);
      index === -1 && dataArr.push({
        "key": { "ECU": element }, "doc_count": 0, [`${chngKey}`]: { "value": 0 }
      })
    });
    let dataA = dataArr.sort(function (a, b) {
      return a.key.ECU.localeCompare(b.key.ECU);
    });
    let dataB = []
    let count = 0
    for (let i = 5; i < 10; i = i + 1) {
      if (count < 4)
        if (dataA[i]) {
          dataB[count] = dataA[i]
          count++
        }
    }
    return dataB;
  }

  function addECUPercentFault(arr, data) {
    const max_value = Math.max.apply(Math, data.map(function (o) { return o.vehicle_count.value; }));
    let percentArr = [];

    arr.map((val, i) => {
      var percent = Math.ceil((val.vehicle_count.value / max_value) * 100);
      percentArr.push(isNaN(percent) ? 0 : percent);
    })
    return percentArr
  }
  function addECUPercentFault_(arr, data) {
    const max_value = Math.max.apply(Math, data.map(function (o) { return o.vehicle_count.value; }));
    let percentArr = [];

    arr.map((val, i) => {
      var percent = Math.ceil((val.vehicle_count.value / max_value) * 100);
      percentArr.push(isNaN(percent) ? 0 : percent);
    })
    return percentArr
  }
  // const responceData = (data) => {
  //   const ecu = addECU(data, "occ")
  //   setFaultPercent(addECUPercentFault(ecu));
  //   setTableBarData(ecu)
  // }

  function generateBarGraph(wrapper) {
    var values = [];
    $(wrapper + ' .bar_bus').each(function (index, el) {
      values.push($(this).data('value'));
    });
    // Get Max Value From Array
    var max_value = Math.max.apply(Math, values);
    // Set width of bar to percent of max value
    $(wrapper + ' .bar_bus').each(function (index, el) {
      var bar = $(this),
        value = bar.data('value'),
        percent = Math.ceil((value / max_value) * 100);
      // Set Width & Add Class
      // bar.width(percent + '%');
      bar.addClass('in');
    });
  }

  useEffect(() => {
    generateBarGraph('#dashboard-stats');
    generateBarGraph('#dashboard-statsUFA')
    generateBarGraph('#dashboard-statsDTC')

  }, [tableBarData, tableAlarmData, tableDtcData]);

  return (
    <div className="row mt-4 mb-3 equal-cols">
      <div className="col-md-3 col-sm-12 pr-0">
        <div className="v-title chartboxPageOne_bus">
          <div className="row titlebg_bus1">
            <div className="col-md-12 col-sm-6 col-lg-7">
              <div className="text-left">Top 10 Vehicle with Fault</div>
            </div>
            <div className="col-md-12 col-sm-6 col-lg-5 py-1">
              <select className="form-select form-select-sm" aria-label="Default select example" onChange={filterChnaged} value={faultSelected}>
                <option value="Duration">Duration</option>
                <option value="Occurrence">Occurrence</option>
              </select>
            </div>
          </div>
          <div className="chartHGT">
            <WaterMark />
            <div className="table-responsive ">
              {((boxOne) && (isLoading) ? <ChartLoader /> : <Table data={tableData} head={tableheadNew} singleVinSelected={singleVinSelected} post_fix={post_fix} />)}
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 col-sm-12 pr-0">
        <div className="v-title chartboxPageOne_bus">
          <div className="row titlebg_bus1">
            <div className="col-md-12 col-sm-6 col-lg-7">
              <div className="text-left">Top 10 Vehicle with Current Imbalance</div>
            </div>
            <div className="col-md-12 col-sm-6 col-lg-5 py-1" >
              <select className="form-select form-select-sm" aria-label="Default select example" onChange={filterChnaged_imbalance} value={faultSelectedimbalance}>
                <option value="Duration">Duration</option>
                <option value="Occurrence">Occurrence</option>
              </select>
            </div>
          </div>
          <div className="chartHGT">
            <WaterMark />
            <div className="table-responsive ">
              {((boxTwo) && (isLoading) ? <ChartLoader /> : <Table data={tableDataImbalnce} head={tablehead} singleVinSelected={singleVinSelected} post_fix={post_fix} />)}
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 col-sm-12 pr-0">
        <div className="v-title chartboxPageOne_bus">
          <div className="titlebg_bus_fault text-fit p-2">Fault analysis</div>
          <div className="row" >
            <div className="col-md-6 col-sm-12 pr-0">
              <div className="chartHGT">
                <div className="boxHead_bus">
                  <div className="float-start">
                    <p className=" boxHeadText">ECU</p>
                  </div>
                  <div className="float-end">
                    <p className="boxHeadText">Vehicle Count</p>
                  </div>
                </div>
                <div className="chart-wrap_bus">
                  <WaterMark />
                  <div id="dashboard-statsUFA" className="chart bars-horizontal brand-primary">
                    {(tableAlarmData.length === 0) ? <NoTableData /> : tableAlarmData.map((x, i) => {
                      if (i < 5) {
                        return (<div className="row" key={x.key}>
                          <span className="label">{x.key.ECU}</span>
                          <div className="bar-wrap_bus">
                            <div className="bar_bus" data-value={x.vehicle_count.value} style={{ width: faultPercentAlram[i] + "%" }} />
                          </div>
                          <span className="number">{x.vehicle_count.value}</span>
                        </div>)
                      }
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 pr-3">
              <div className="chartHGT">
                <div className="boxHead_bus">
                  <div className="float-start">
                    <p className=" boxHeadText">ECU</p>
                  </div>
                  <div className="float-end">
                    <p className="boxHeadText">Vehicle Count</p>
                  </div>
                </div>
                <div className="chart-wrap_bus">
                  <WaterMark />
                  <div id="dashboard-statsUFA" className="chart bars-horizontal brand-primary">
                    {
                      (tableAlarmData_.length === 0) ? <NoTableData /> :
                        tableAlarmData_.map((x, i) => {
                          if (i < 5) {
                            return (
                              <div className="row" key={x.key}>
                                <span className="label">{x.key.ECU}</span>
                                <div className="bar-wrap_bus">
                                  <div className="bar_bus" data-value={x.vehicle_count.value} style={{ width: faultPercentAlram_[i] + "%" }} />
                                </div>
                                <span className="number">{x.vehicle_count.value}</span>
                              </div>
                            )
                          }
                        })}</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 col-sm-12">
        <div className="v-title chartboxPageOne_bus">
          <div className="titlebg_bus_fault text-fit p-2">Alarm analysis</div>
          <div className="row" >
            <div className="col-md-6 col-sm-12 pr-0">
              <div className="chartHGT">
                <div className="boxHead_bus">
                  <div className="float-start">
                    <p className=" boxHeadText">ECU</p>
                  </div>
                  <div className="float-end">
                    <p className="boxHeadText">Vehicle Count</p>
                  </div>
                </div>
                <div className="chart-wrap_bus">
                  <WaterMark />
                  <div id="dashboard-statsDTC" className="chart bars-horizontal brand-primary">
                    {(tableDtcData.length === 0) ? <NoTableData /> : tableDtcData.map((x, i) => {
                      if (i < 5) {
                        return (<div className="row" key={x.key}>
                          <span className="label">{x.key.ECU}</span>
                          <div className="bar-wrap_bus">
                            <div className="bar_bus" data-value={x.vehicle_count.value} style={{ width: faultPercentDtc[i] + "%" }} />
                          </div>
                          <span className="number">{x.vehicle_count.value}</span>
                        </div>)
                      }
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 pr-3">
              <div className="chartHGT">
                <div className="boxHead_bus">
                  <div className="float-start">
                    <p className=" boxHeadText">ECU</p>
                  </div>
                  <div className="float-end">
                    <p className="boxHeadText">Vehicle Count</p>
                  </div>
                </div>
                <div className="chart-wrap_bus">
                  <WaterMark />
                  <div id="dashboard-statsDTC" className="chart bars-horizontal brand-primary">
                    {(tableDtcData_.length === 0) ? <NoTableData /> : tableDtcData_.map((x, i) => {
                      if (i < 4) {
                        return (<div className="row" key={x.key}>
                          <span className="label">{x.key.ECU}</span>
                          <div className="bar-wrap_bus">
                            <div className="bar_bus" data-value={x.vehicle_count.value} style={{ width: faultPercentDtc_[i] + "%" }} />
                          </div>
                          <span className="number">{x.vehicle_count.value}</span>
                        </div>)
                      }
                    })}</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}